module.exports = __webpack_public_path__ + "static/media/close-dollor-brand.b5b611e6.svg";